/*
 * YAMIWARD — RESIDENT IDENTITY (身元)
 *
 * A resident's uid is the bearer key to their bloodline, seals, scores and EN, so
 * the browser no longer invents one: the Ward Board issues it and signs it, and
 * every write carries {uid, token}. Acting as someone else's uid is impossible
 * without their token, which never leaves the device that was issued it.
 *
 * Loads BEFORE every other board script so window.YW_ID is always available.
 *
 * Storage:
 *   yw_uid / yw_token — the signed identity
 *   yd_uid            — legacy pre-identity uid, migrated once then left in place
 */
(function () {
    var BOARD_API = 'https://api.yamiward.com';
    var UID_KEY = 'yw_uid', TOK_KEY = 'yw_token', LEGACY_KEY = 'yd_uid';

    function read() {
        try {
            var uid = localStorage.getItem(UID_KEY), token = localStorage.getItem(TOK_KEY);
            return uid && token ? { uid: uid, token: token } : null;
        } catch (e) { return null; }
    }
    function write(uid, token) {
        try { localStorage.setItem(UID_KEY, uid); localStorage.setItem(TOK_KEY, token); } catch (e) { /* private mode */ }
        return { uid: uid, token: token };
    }
    function legacyUid() {
        try { return localStorage.getItem(LEGACY_KEY) || ''; } catch (e) { return ''; }
    }

    function mint() {
        return fetch(BOARD_API + '/api/identity', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}'
        }).then(function (r) { return r.json(); }).then(function (d) {
            if (!d || !d.uid || !d.token) throw new Error('identity: mint failed');
            return write(d.uid, d.token);
        });
    }

    // A device that played before identities were signed keeps its history: the
    // uid it already holds is claimed once, in exchange for a token. If it was
    // already claimed (or has no history), start fresh instead of failing.
    function migrate(uid) {
        return fetch(BOARD_API + '/api/identity/migrate', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uid: uid })
        }).then(function (r) { return r.json(); }).then(function (d) {
            if (d && d.ok && d.uid && d.token) return write(d.uid, d.token);
            return mint();
        }).catch(function () { return mint(); });
    }

    function resolve() {
        var have = read();
        if (have) return Promise.resolve(have);
        var legacy = legacyUid();
        return legacy ? migrate(legacy) : mint();
    }

    // One in-flight resolution shared by every caller on the page.
    var ready = resolve().catch(function (e) {
        console.error('identity: could not establish a resident identity', e);
        return null;
    });

    window.YW_ID = {
        ready: ready,
        // Synchronous read for render paths that only need a display value.
        get: read,
        // Store an identity handed back by the account link (customer-owned).
        adopt: function (uid, token) { return uid && token ? write(uid, token) : null; },
        // POST with the identity merged in. Body may be omitted.
        post: function (url, body) {
            return ready.then(function (id) {
                var payload = Object.assign({}, body || {});
                if (id) { payload.uid = id.uid; payload.token = id.token; }
                return fetch(url, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });
            });
        },
        // GET with the identity appended as query params.
        get_: function (url) {
            return ready.then(function (id) {
                var sep = url.indexOf('?') === -1 ? '?' : '&';
                var q = id ? sep + 'uid=' + encodeURIComponent(id.uid) + '&token=' + encodeURIComponent(id.token) : '';
                return fetch(url + q);
            });
        },
        // The uid alone, once resolved — for callers that build their own request.
        uid: function () { return ready.then(function (id) { return id ? id.uid : ''; }); }
    };
})();
